export default __webpack_public_path__ + "static/media/guide-to-front-off.866f71af.svg";